import { apiClient } from "./client";
import type {
  WheelTier,
  WheelTierName,
  SpinResult,
} from "@stellex-tycoon/shared-types";

export async function fetchTiers(): Promise<WheelTier[]> {
  const { data } = await apiClient.get<WheelTier[]>("/wheel/tiers");
  return data;
}

export async function spinWheel(tier: WheelTierName): Promise<{ spinId: string }> {
  const { data } = await apiClient.post<{ spinId: string }>("/wheel/spin", { tier });
  return data;
}

export async function fetchSpinResult(spinId: string): Promise<SpinResult> {
  const { data } = await apiClient.get<SpinResult>(`/wheel/spin/${spinId}`);
  return data;
}

export async function fetchSpinHistory(limit = 20): Promise<unknown[]> {
  const { data } = await apiClient.get("/wheel/me/history", { params: { limit } });
  return data as unknown[];
}
